import React from "react";
import { Card, CardTitle, CardDescription } from "@/components/ui";
import { CircleCheck } from "lucide-react";
import { clsx } from "clsx";

interface CardOptionProps {
  selected: boolean;
  title: string;
  description?: string;
  disabled?: boolean;
  className?: string;
}

export const CardOption = ({
  selected,
  title,
  description,
  disabled = false,
  className = "",
  ...props
}: CardOptionProps) => {
  return (
    <Card
      className={clsx(
        "bg-transparent shadow-xs dark:bg-input/30",
        disabled
          ? "opacity-50"
          : "transition-[color,box-shadow] hover:bg-accent hover:text-accent-foreground dark:hover:bg-input/50",
        { "mx-[-1px] border-2 border-blue-primary": selected },
        className,
      )}
      aria-selected={selected}
      {...props}
    >
      <div className="flex px-4 py-3 text-left">
        <div className="flex grow flex-col">
          <CardTitle className="text-sm">
            <div className="flex">
              <p className="grow">{title}</p>
            </div>
          </CardTitle>
          {description ? (
            <CardDescription>{description}</CardDescription>
          ) : (
            <></>
          )}
        </div>
        <div className="w-4">
          {selected ? (
            <CircleCheck
              className="text-base"
              fill="var(--blue-primary)"
              color="white"
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </Card>
  );
};
